import { YOO_FINDS_CDN } from "@/common";

const baseUrl = `${YOO_FINDS_CDN}/pc/fgvcon-2025`;

export const FGVCON_2025_BANNER = `${baseUrl}/fgvcon-2025-banner.png`;

export const FGVCON_2025_ALLE = `${baseUrl}/fgvcon-2025-Alle%20%28USA%29.png`;

export const FGVCON_2025_ANGIE_ROMAN = `${baseUrl}/fgvcon-2025-angie_roman.png`;

export const FGVCON_2025_BROOKLYN = `${baseUrl}/fgvcon-2025-brooklyn.png`;

export const FGVCON_2025_CASSANDRA = `${baseUrl}/fgvcon-2025-Cassandra%20Bankson%20%28USA%29.png`;

export const FGVCON_2025_ELISABETH_COOK = `${baseUrl}/fgvcon-2025-Elisabeth%20Cook%20%28USA%29.png`;

export const FGVCON_2025_PIERRE_DALATI = `${baseUrl}/fgvcon-2025-Pierre%20Dalati%20%28USA%29.png`;

export const FGVCON_2025_CREATORS = `${baseUrl}/fgvcon-2025-creator_v2.png`;

export const FGVCON_2025_INFLUENCERS = `${baseUrl}/fgvcon-2025-influencers.png`;
